import React, { useState, useEffect, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import PopupFinDePartie from "./PopupFinDePartie";
import MiniSpaceInvaders from "./MiniSpaceInvaders";
import { useNavigate } from "react-router-dom";




const couleurEnAnglais = {
    rouge: "red",
    bleu: "blue",
    vert: "green",
    jaune: "yellow",
    noir: "black",
    violet: "purple"
};

function traduireCouleur(couleur) {
    return couleur && typeof couleur === "string"
        ? couleurEnAnglais[couleur.toLowerCase()] || "black"
        : "black";
}

function JouerNiveau() {
    const { murId } = useParams();
    const [mur, setMur] = useState(null);
    const [formesDisponibles, setFormesDisponibles] = useState([]);
    const [score, setScore] = useState(0);
    const [vies, setVies] = useState(3);
    const [gameStarted, setGameStarted] = useState(false);
    const [isBallReady, setIsBallReady] = useState(true);
    const isBallReadyRef = useRef(true);
    const gameStartedRef = useRef(false);
    const [popupFin, setPopupFin] = useState(null);
    const animationRef = useRef(null);
    const [effetActif, setEffetActif] = useState(null);
    const effetBonus = ["balle_lente", "raquette_large", "balle_large"];
    const effetMalus = ["balle_rapide", "raquette_petite", "balle_mini"];
    const [miniJeuActif, setMiniJeuActif] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        isBallReadyRef.current = isBallReady;
      }, [isBallReady]);

      useEffect(() => {
        gameStartedRef.current = gameStarted;
      }, [gameStarted]);

    const murCanvasRef = useRef(null);
    const canvasWidth = 1000;
    const canvasHeight = 500;
    const paddleheight = 10;
    const paddleWidth = 75;
    const paddleX = (canvasWidth - paddleWidth) / 2;

    const ballRef = useRef({ x: canvasWidth / 2, y: canvasHeight - 30, dx: 2, dy: -2, radius: 10 });
    const paddleref = useRef({ x: paddleX, y: canvasHeight - paddleheight, dx: 2, dy: 2, width: paddleWidth, height: paddleheight });

   
    const collisionDetection = (balle) => {
        if (!mur) return;
    
        mur.briques.forEach((forme) => {
            if (!forme.active) return;
    
            const collision = detectCollision(balle, forme);
    
            if (collision) {
                if (collision.bounceX) balle.dx = -balle.dx;
                if (collision.bounceY) balle.dy = -balle.dy;
    
                // Gérer score et effets
                const type = forme.nom.toLowerCase();
    
                if (type.includes("rectangle")) {
                    forme.active = false;
                    setScore(prev => prev + 20);
                } else if (type.includes("rond")) {
                    forme.active = false;
                    setScore(prev => prev - 10);

                    const effet = effetMalus[Math.floor(Math.random() * effetMalus.length)];
                    activerEffet(effet);
                } else if (type.includes("hexagone")) {
                    forme.active = false;
                    setScore(prev => prev + 50);
                    setVies(prev => prev + 1);
                    const effet = effetBonus[Math.floor(Math.random() * effetBonus.length)];
                    activerEffet(effet);
                } 
            }
        });
        const remainingRectangles = mur.briques.filter(b => b.active && b.nom.toLowerCase().includes("rectangle")).length;
        if (remainingRectangles === 0) {
            clearInterval(animationRef.current);
            //setPopupFin("victoire");
            setMiniJeuActif(true);
        }
    };

    useEffect(() => {
        document.body.classList.toggle("modal-open", miniJeuActif);
      }, [miniJeuActif]);
      

    const activerEffet = (type) => {
        const ball = ballRef.current;
        const paddle = paddleref.current;
        const originalRadius = ball.radius;

        if(type === "balle_lente") {
            ball.dx *= 0.5;
            ball.dy *= 0.5;
            setEffetActif("balle lente");

            setTimeout(() => {
                ball.dx *= 2;
                ball.dy *= 2;
                setEffetActif(null);
            }, 8000);
        }

        if(type === "balle_rapide") {
            ball.dx *= 1.5;
            ball.dy *= 1.5;
            setEffetActif("balle rapide")

            setTimeout(() => {
                ball.dx /= 1.5;
                ball.dy /= 1.5;
                setEffetActif(null);
            }, 8000);
        }
        if (type === "raquette_large") {
            paddle.width += 50;
            setEffetActif("raquette large");
    
            setTimeout(() => {
                paddle.width -= 50;
                setEffetActif(null);
            }, 8000);
        }
    
        if (type === "raquette_petite") {
            paddle.width = Math.max(30, paddle.width / 2);
            setEffetActif("mini raquette");
    
            setTimeout(() => {
                paddle.width = 75; 
                setEffetActif(null);
            }, 8000);
        }

        if(type === "balle_large") {
            ball.radius = 15;
            setEffetActif("balle large");

            setTimeout(() => {
                ball.radius = originalRadius;
                setEffetActif(null);
            }, 8000);
        }

        if(type === "balle_mini") {
            ball.radius = 5;
            setEffetActif("balle mini");

            setTimeout(() => {
                ball.radius = originalRadius;
                setEffetActif(null);
            }, 8000);
        }
    }

    const getTriangleBounds = (forme) => {
        const x = forme.posX;
        const y = forme.posY;
        const base = forme.base;
        const hauteur = forme.hauteur;
    
        const minX = base >= 0 ? x : x + base;
        const maxX = base >= 0 ? x + base : x;
        const minY = hauteur >= 0 ? y : y + hauteur;
        const maxY = hauteur >= 0 ? y + hauteur : y;
    
        return { minX, maxX, minY, maxY };
    };
    
    const detectTriangleCollision = (balle, forme) => {
        const { x, y, radius = 5 } = balle;
        const base = forme.base;
        const hauteur = forme.hauteur;
    
        const absBase = Math.abs(base);
        const absHauteur = Math.abs(hauteur);
    
        const { minX, maxX, minY, maxY } = getTriangleBounds(forme);
    
        // Si balle en dehors du rectangle englobant => pas de collision
        if (x + radius < minX || x - radius > maxX || y + radius < minY || y - radius > maxY) {
            return false;
        }
    
        // Calcul de la position relative à l'origine du triangle
        const relX = x - minX;
        const relY = y - minY;
    
        // Calcul de l’équation du triangle selon l’orientation
        if (base * hauteur > 0) {
            // Triangle orienté ↘️ (bas/droite) ou ↖️ (haut/gauche)
            return relY <= (absHauteur / absBase) * relX;
        } else {
            // Triangle orienté ↙️ (bas/gauche) ou ↗️ (haut/droite)
            return relY <= (absHauteur / absBase) * (absBase - relX);
        }
    };

    const detectCollision = (balle, forme) => {
        const { x, y, radius = 10, dx, dy } = balle;
        const type = forme.nom.toLowerCase();
    
        let collided = false;
        let bounceX = false;
        let bounceY = false;
    
        if (type.includes("rectangle") || type.includes("hexagone")) {
            const left = forme.posX;
            const right = forme.posX + (forme.longueur || forme.cotes);
            const top = forme.posY;
            const bottom = forme.posY + (forme.largeur || forme.cotes);
    
            if (x + radius > left && x - radius < right &&
                y + radius > top && y - radius < bottom) {
                collided = true;
    
                const overlapLeft = Math.abs((x + radius) - left);
                const overlapRight = Math.abs((x - radius) - right);
                const overlapTop = Math.abs((y + radius) - top);
                const overlapBottom = Math.abs((y - radius) - bottom);
    
                const minOverlap = Math.min(overlapLeft, overlapRight, overlapTop, overlapBottom);
    
                if (minOverlap === overlapLeft || minOverlap === overlapRight) {
                    bounceX = true;
                } else {
                    bounceY = true;
                }
            }
    
        } else if (type.includes("rond")) {
            const cx = forme.posX + forme.rayon;
            const cy = forme.posY + forme.rayon;
            const dxBall = x - cx;
            const dyBall = y - cy;
            const distance = Math.sqrt(dxBall * dxBall + dyBall * dyBall);
    
            if (distance < forme.rayon + radius) {
                collided = true;
                bounceX = true;
                bounceY = true;
            }
    
        } else if (type.includes("triangle")) {
            if (detectTriangleCollision(balle, forme)) {
                collided = true;
                bounceY = true;
            }
        }
    
        return collided ? { bounceX, bounceY } : null;
    };

    const dessinerFormesEtBalle = useCallback(() => {
        const canvas = murCanvasRef.current;
        if (!canvas || !mur) return;

        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        mur.briques.forEach((forme) => {
            if (!forme.active) return;
            const couleur = traduireCouleur(forme.couleur);
            ctx.fillStyle = couleur;
            ctx.save();

            if (forme.nom.toLowerCase().includes("rectangle")) {
                ctx.fillRect(forme.posX, forme.posY, forme.largeur, forme.longueur);
            } else if (forme.nom.toLowerCase().includes("rond")) {
                ctx.beginPath();
                ctx.arc(forme.posX, forme.posY, forme.rayon, 0, Math.PI * 2);
                ctx.fill();
            } else if (forme.nom.toLowerCase().includes("triangle")) {
                ctx.beginPath();
                ctx.moveTo(forme.posX, forme.posY);
                ctx.lineTo(forme.posX + forme.base, forme.posY);
                ctx.lineTo(forme.posX, forme.posY - forme.hauteur);
                ctx.closePath();
                ctx.fill();
            } else if (forme.nom.toLowerCase().includes("hexagone")) {
                const cote = forme.cotes || 10;
                ctx.beginPath();
                for (let i = 0; i < 6; i++) {
                    const angle = (Math.PI / 3) * i;
                    const x = forme.posX + Math.cos(angle) * cote;
                    const y = forme.posY + Math.sin(angle) * cote;
                    if (i === 0) ctx.moveTo(x, y);
                    else ctx.lineTo(x, y);
                }
                ctx.closePath();
                ctx.fill();
            }

            ctx.restore();
        });

        const ball = ballRef.current;
        ctx.beginPath();
        ctx.arc(ball.x, ball.y, ball.radius, 0, Math.PI * 2);
        ctx.fillStyle = "#0095DD";
        ctx.fill();
        ctx.closePath();

        const paddle = paddleref.current;
        ctx.beginPath();
        ctx.rect(paddle.x, paddle.y, paddle.width, paddle.height);
        ctx.fillStyle = "#0095DD";
        ctx.fill();
        ctx.closePath();
    }, [mur]);

    useEffect(() => {
        let rightPressed = false;
        let leftPressed = false;

        const handleKeyDown = (e) => {
            if((e.key === "Up" || e.key === "ArrowUp") && isBallReadyRef.current) {
                console.log("🚀 Lancement de la balle !");
                setGameStarted(true);
                setIsBallReady(false);
            }
            if (e.key === "Right" || e.key === "ArrowRight") rightPressed = true;
            if (e.key === "Left" || e.key === "ArrowLeft") leftPressed = true;
        };

        const handleKeyUp = (e) => {
            if (e.key === "Right" || e.key === "ArrowRight") rightPressed = false;
            if (e.key === "Left" || e.key === "ArrowLeft") leftPressed = false;
        };

        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("keyup", handleKeyUp);

        const animatePaddle = () => {
            const paddle = paddleref.current;
            if (rightPressed) {
                paddle.x += 5;
                if (paddle.x + paddle.width > canvasWidth) {
                    paddle.x = canvasWidth - paddle.width;
                }
            } else if (leftPressed) {
                paddle.x -= 5;
                if (paddle.x < 0) {
                    paddle.x = 0;
                }
            }

            dessinerFormesEtBalle();
            requestAnimationFrame(animatePaddle);
        };

        animatePaddle();

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("keyup", handleKeyUp);
        };
    }, [dessinerFormesEtBalle]);

    useEffect(() => {
        animationRef.current = setInterval(() => {
            const canvas = murCanvasRef.current;
            if (!canvas || !mur) return;

            if (!gameStartedRef.current) {
                if (isBallReadyRef.current) {
                    const ball = ballRef.current;
                    const paddle = paddleref.current;
                    ball.x = paddle.x + paddle.width / 2;
                    ball.y = paddle.y - ball.radius;
                    dessinerFormesEtBalle();
                  }
            
                return; 
            }
            const ball = ballRef.current;
            const paddle = paddleref.current;
            if (ball.x + ball.dx > canvas.width - ball.radius || ball.x + ball.dx < ball.radius) {
                ball.dx = -ball.dx;
            }
            if (ball.y + ball.dy < ball.radius) {
                ball.dy = -ball.dy;
            } else if (ball.y + ball.dy > canvas.height - ball.radius) {
                if (ball.x > paddle.x && ball.x < paddle.x + paddle.width) {
                    ball.dy = -ball.dy;
                } else {
                    setVies(prev => {
                        const newVies = prev - 1;
                        if (newVies <= 0) {
                            clearInterval(animationRef.current); 
                            setPopupFin("defaite"); 
                        } else {
                            setIsBallReady(true);
                            setGameStarted(false);
                        }
                        return newVies;
                    });
                    ball.x = canvas.width / 2;
                    ball.y = canvas.height - 30;
                    ball.dx = 2;
                    ball.dy = -2;
                }
            }

            ball.x += ball.dx;
            ball.y += ball.dy;

            dessinerFormesEtBalle();
            collisionDetection(ball);
            
        }, 10);

        return () => clearInterval(animationRef.current);
    }, [dessinerFormesEtBalle, mur]);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_ADMIN_URL}/formes`)
            .then((res) => res.json())
            .then(setFormesDisponibles)
            .catch((err) => console.error("Erreur API Formes :", err));
    }, []);

    useEffect(() => {
        if (!murId || formesDisponibles.length === 0) return;

        fetch(`${process.env.REACT_APP_API_USER_URL}/MurDeBrique/${murId}`)
            .then((res) => res.json())
            .then((murData) => {
                const briquesAvecDetails = murData.briques.map((brique, index) => {
                    const details = formesDisponibles.find((f) => f.id === brique.formId);
                    if (!details) return null;
                    return {
                        ...details,
                        posX: brique.posX,
                        posY: brique.posY,
                        murFormeId: brique.id,
                        uniqueId: `${brique.id}-${index}`,
                        active: true
                    };
                }).filter(Boolean);

                setMur({ ...murData, briques: briquesAvecDetails });
            })
            .catch((err) => console.error("Erreur API Mur :", err));
    }, [murId, formesDisponibles]);

    return (
        <div className="mur-wrapper">
            <h2>🎮 Jouer le niveau</h2>
            <div
            style={{
                textAlign: "center",
                fontSize: "20px",
                color: "#0095DD",
                marginBottom: "10px",
                height: "24px", 
                animation: isBallReady ? "blinker 1s linear infinite" : "none",
                visibility: isBallReady ? "visible" : "hidden",
            }}
            >
            🎯 Appuyez sur ↑ pour lancer la balle
            </div>
            <div className="canvas-container">
            <div style={{ display: "flex", justifyContent: "space-between", width: canvasWidth, marginBottom: 10 }}>
                <h3>🏆 Score : {score}</h3>
                {effetActif && (
                <p>
                    ⚡ Effet actif : {effetActif}
                </p>
                )}
                <h3>❤️ Vies : {vies}</h3>
            </div>
                <canvas
                    ref={murCanvasRef}
                    width={canvasWidth}
                    height={canvasHeight}
                    className="canvas-wrapper"
                />
            </div>
            {popupFin && (
                <PopupFinDePartie
                    message={popupFin === "victoire" ? "🎉 Bravo ! Niveau terminé !" : "💀 Game Over !"}
                    onRejouer={() => document.location.reload()}
                    onRetour={() => navigate("/")}
                />
            )}
            {miniJeuActif && (
                <MiniSpaceInvaders onTermine={() => {
                    setMiniJeuActif(false);
                    setPopupFin("victoire");
                }} />
                )}
        </div>
    );
}

export default JouerNiveau;